import React from "react";

const Order = () => {
	return (
		<div>
			<h1>this is order</h1>
		</div>
	);
};

export default Order;
